import "./globals.css";
import "antd/dist/reset.css";
import React, { Suspense } from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { Spin } from "antd";
import { SidebarProvider } from "./components/ui/sidebar";
import { AppSidebar } from "./components/side-bar/AppSidebar";
import { ProtectedRoute } from "./Hook";
import { ReportStoreProvider } from "./Page/reports/ReportStoreContext";
import { REPORT, ROUTE } from "./Constant";
import { KeyboardHandlerNavToPos } from "./components";

const PageLoading = () => (
  <div className="flex justify-center items-center h-screen">
    <Spin size="large" />
  </div>
);

const SignInPage = React.lazy(() =>
  import("./Page/sign-in/SignIn").then((m) => ({ default: m.SignInPage })),
);
const ForgotPasswordPage = React.lazy(() =>
  import("./Page/forgot-password/ForgotPassword").then((m) => ({
    default: m.ForgotPasswordPage,
  })),
);
const LoginSuccessPage = React.lazy(() =>
  import("./Page/login-success/LoginSuccess").then((m) => ({
    default: m.LoginSuccessPage,
  })),
);
const AutoLoginPage = React.lazy(() =>
  import("./Page/auto-login/AutoLogin").then((m) => ({
    default: m.AutoLoginPage,
  })),
);

const POSPage = React.lazy(() =>
  import("./Page/pos/POSPage").then((m) => ({ default: m.POSPage })),
);
const SalesPurchasePage = React.lazy(() =>
  import("./Page/pos/SalesPurchasePage").then((m) => ({
    default: m.SalesPurchasePage,
  })),
);
const EmployeesPage = React.lazy(() =>
  import("./Page/employees/Employees").then((m) => ({
    default: m.EmployeesPage,
  })),
);
const AttendanceRegisterPage = React.lazy(() =>
  import("./Page/hr/AttendanceRegister").then((m) => ({
    default: m.AttendanceRegisterPage,
  })),
);
const ShiftManagementPage = React.lazy(() =>
  import("./Page/hr/ShiftManagementPage").then((m) => ({
    default: m.ShiftManagementPage,
  })),
);
const PayrollPolicyPage = React.lazy(() =>
  import("./Page/hr/PayrollPolicyPage").then((m) => ({
    default: m.PayrollPolicyPage,
  })),
);
const PayrollManagementPage = React.lazy(() =>
  import("./Page/hr/PayrollManagement").then((m) => ({
    default: m.PayrollManagementPage,
  })),
);
const SalaryCompensationPage = React.lazy(() =>
  import("./Page/hr/SalaryCompensation").then((m) => ({
    default: m.SalaryCompensationPage,
  })),
);
const LeaveCalendar = React.lazy(() =>
  import("./Page/hr/LeaveCalendar").then((m) => ({
    default: m.LeaveCalendar,
  })),
);
const UsersPage = React.lazy(() =>
  import("./Page/users/Users").then((m) => ({ default: m.UsersPage })),
);
const AccessPoliciesPage = React.lazy(() =>
  import("./Page/access-policies/AccessPoliciesPage").then((m) => ({
    default: m.AccessPoliciesPage,
  })),
);
const StoresPage = React.lazy(() =>
  import("./Page/stores/StoresPage").then((m) => ({ default: m.StoresPage })),
);
const RoutesPage = React.lazy(() =>
  import("./Page/routes-manage/RoutesPage").then((m) => ({
    default: m.RoutesPage,
  })),
);
const BankAccountsPage = React.lazy(() =>
  import("./Page/bank-accounts/BankAccountsPage").then((m) => ({
    default: m.BankAccountsPage,
  })),
);
const PreBookingsPage = React.lazy(() =>
  import("./Page/bookings/PreBookingsPage").then((m) => ({
    default: m.PreBookingsPage,
  })),
);
const WhatsAppChatbotPage = React.lazy(() =>
  import("./Page/whatsapp-chatbot/WhatsAppChatbotPage").then((m) => ({
    default: m.WhatsAppChatbotPage,
  })),
);
const OnlineOrdersPage = React.lazy(() =>
  import("./Page/online-orders/OnlineOrdersPage").then((m) => ({
    default: m.OnlineOrdersPage,
  })),
);
const ProductsPage = React.lazy(() =>
  import("./Page/products/ProductsPage").then((m) => ({
    default: m.ProductsPage,
  })),
);
const BarcodeEditor = React.lazy(() =>
  import("./Page/barcode-editor/BarcodeEditor").then((m) => ({
    default: m.BarcodeEditor,
  })),
);
const PurchasesPage = React.lazy(() =>
  import("./Page/purchases/Purchases").then((m) => ({
    default: m.PurchasesPage,
  })),
);
const RawMaterialsPage = React.lazy(() =>
  import("./Page/raw-materials/RawMaterials").then((m) => ({
    default: m.RawMaterialsPage,
  })),
);
const RawPurchasesPage = React.lazy(() =>
  import("./Page/raw-material-purchase/RawPurchases").then((m) => ({
    default: m.RawPurchasesPage,
  })),
);
const RawPurchaseFormStandalonePage = React.lazy(() =>
  import("./Page/raw-material-purchase/RawPurchaseFormStandalonePage").then(
    (m) => ({
      default: m.RawPurchaseFormStandalonePage,
    }),
  ),
);
const RecipesPage = React.lazy(() =>
  import("./Page/recipes/Recipes").then((m) => ({ default: m.RecipesPage })),
);
const WorkshopsPage = React.lazy(() =>
  import("./Page/workshops/WorkshopsPage").then((m) => ({
    default: m.WorkshopsPage,
  })),
);
const WorkshopDetailPage = React.lazy(() =>
  import("./Page/workshops/WorkshopDetailPage").then((m) => ({
    default: m.WorkshopDetailPage,
  })),
);
const ProductionPage = React.lazy(() =>
  import("./Page/production/Production").then((m) => ({
    default: m.ProductionPage,
  })),
);
const StockTransferPage = React.lazy(() =>
  import("./Page/stock-transfer/StockTransfer").then((m) => ({
    default: m.StockTransferPage,
  })),
);
const StockAdjustmentPage = React.lazy(() =>
  import("./Page/stock-adjustment/StockAdjustment").then((m) => ({
    default: m.StockAdjustmentPage,
  })),
);
const StockHistoryPage = React.lazy(() =>
  import("./Page/stock-history/StockHistoryPage").then((m) => ({
    default: m.StockHistoryPage,
  })),
);
const StoreLiveTracking = React.lazy(() =>
  import("./Page/stores/StoreLiveTracking").then((m) => ({
    default: m.StoreLiveTracking,
  })),
);
const RepairJobsPage = React.lazy(() =>
  import("./Page/repairJobsPage/RepairJobsPage").then((m) => ({
    default: m.RepairJobsPage,
  })),
);
const CouriersPage = React.lazy(() =>
  import("./Page/couriersPage/CouriersPage").then((m) => ({
    default: m.CouriersPage,
  })),
);
const CourierLedgerPage = React.lazy(() =>
  import("./Page/courierLedgerPage/CourierLedgerPage").then((m) => ({
    default: m.CourierLedgerPage,
  })),
);
const SellingHistory = React.lazy(() =>
  import("./Page/selling-history/SellingHistory").then((m) => ({
    default: m.SellingHistory,
  })),
);
const ReturnsHistory = React.lazy(() =>
  import("./Page/returnPage/ReturnsHistory").then((m) => ({
    default: m.ReturnsHistory,
  })),
);
const ExpensesPage = React.lazy(() =>
  import("./Page/expensesPage/ExpensesPage").then((m) => ({
    default: m.ExpensesPage,
  })),
);
const CustomerLedgerPage = React.lazy(() =>
  import("./Page/creditsPage/customer-ledger/CustomerLedgerPage").then((m) => ({
    default: m.CustomerLedgerPage,
  })),
);
const SupplierLedgerPage = React.lazy(() =>
  import("./Page/creditsPage/supplier-ledger/SupplierLedgerPage").then((m) => ({
    default: m.SupplierLedgerPage,
  })),
);
const CreditsPage = React.lazy(() =>
  import("./Page/creditsPage/CreditsPage").then((m) => ({
    default: m.CreditsPage,
  })),
);
const ChequesPage = React.lazy(() =>
  import("./Page/cheques/ChequesPage").then((m) => ({
    default: m.ChequesPage,
  })),
);
const CustomersPage = React.lazy(() =>
  import("./Page/customersPage/CustomersPage").then((m) => ({
    default: m.CustomersPage,
  })),
);
const SuppliersPage = React.lazy(() =>
  import("./Page/suppliersPage/SuppliersPage").then((m) => ({
    default: m.SuppliersPage,
  })),
);
const QuotationsPage = React.lazy(() =>
  import("./Page/quotationsPage/QuotationsPage").then((m) => ({
    default: m.QuotationsPage,
  })),
);
const DraftsPage = React.lazy(() =>
  import("./Page/draftsPage/DraftsPage").then((m) => ({
    default: m.DraftsPage,
  })),
);
const SalesReports = React.lazy(() =>
  import("./Page/reports/SalesReports").then((m) => ({
    default: m.SalesReports,
  })),
);
const InventoryReports = React.lazy(() =>
  import("./Page/reports/InventoryReports").then((m) => ({
    default: m.InventoryReports,
  })),
);
const PurchaseReports = React.lazy(() =>
  import("./Page/reports/PurchaseReports").then((m) => ({
    default: m.PurchaseReports,
  })),
);
const ExpenseReports = React.lazy(() =>
  import("./Page/reports/ExpenseReports").then((m) => ({
    default: m.ExpenseReports,
  })),
);
const CreditReports = React.lazy(() =>
  import("./Page/reports/CreditReports").then((m) => ({
    default: m.CreditReports,
  })),
);
const OtherReports = React.lazy(() =>
  import("./Page/reports/OtherReports").then((m) => ({
    default: m.OtherReports,
  })),
);
const SalesLedgerReport = React.lazy(() =>
  import("./Page/reports/sub-report/SalesLedgerReport").then((m) => ({
    default: m.SalesLedgerReport,
  })),
);
const ItemProfitReport = React.lazy(() =>
  import("./Page/reports/sub-report/ItemProfitReport").then((m) => ({
    default: m.ItemProfitReport,
  })),
);
const CashFlowReport = React.lazy(() =>
  import("./Page/reports/sub-report/CashFlowReport").then((m) => ({
    default: m.CashFlowReport,
  })),
);
const ChequesReport = React.lazy(() =>
  import("./Page/reports/sub-report/ChequesReport").then((m) => ({
    default: m.ChequesReport,
  })),
);
const DiscountsReport = React.lazy(() =>
  import("./Page/reports/sub-report/DiscountsReport").then((m) => ({
    default: m.DiscountsReport,
  })),
);
const NonCashPaymentsReport = React.lazy(() =>
  import("./Page/reports/sub-report/NonCashPaymentsReport").then((m) => ({
    default: m.NonCashPaymentsReport,
  })),
);
const EmployeePerformanceReport = React.lazy(() =>
  import("./Page/reports/sub-report/EmployeePerformanceReport").then((m) => ({
    default: m.EmployeePerformanceReport,
  })),
);
const SignOffListReport = React.lazy(() =>
  import("./Page/reports/sub-report/SignOffListReport").then((m) => ({
    default: m.SignOffListReport,
  })),
);
const SignOffDetailReport = React.lazy(() =>
  import("./Page/reports/sub-report/SignOffDetailReport").then((m) => ({
    default: m.SignOffDetailReport,
  })),
);
const ProductStockReport = React.lazy(() =>
  import("./Page/reports/sub-report/ProductStockReport").then((m) => ({
    default: m.ProductStockReport,
  })),
);
const ExpiringItemsReport = React.lazy(() =>
  import("./Page/reports/sub-report/ExpiringItemsReport").then((m) => ({
    default: m.ExpiringItemsReport,
  })),
);
const PurchasesReport = React.lazy(() =>
  import("./Page/reports/sub-report/PurchasesReport").then((m) => ({
    default: m.PurchasesReport,
  })),
);
const PurchasedProductsReport = React.lazy(() =>
  import("./Page/reports/sub-report/PurchasedProductsReport").then((m) => ({
    default: m.PurchasedProductsReport,
  })),
);
const ReturnedItemsReport = React.lazy(() =>
  import("./Page/reports/sub-report/ReturnedItemsReport").then((m) => ({
    default: m.ReturnedItemsReport,
  })),
);
const SoldItemsReport = React.lazy(() =>
  import("./Page/reports/sub-report/SoldItemsReport").then((m) => ({
    default: m.SoldItemsReport,
  })),
);
const CourierReport = React.lazy(() =>
  import("./Page/reports/sub-report/CourierReport").then((m) => ({
    default: m.CourierReport,
  })),
);
const ReportByCashier = React.lazy(() =>
  import("./Page/reports/sub-report/ReportByCashier").then((m) => ({
    default: m.ReportByCashier,
  })),
);
const TotalItemsReport = React.lazy(() =>
  import("./Page/reports/sub-report/TotalItemsReport").then((m) => ({
    default: m.TotalItemsReport,
  })),
);
const ProductReport = React.lazy(() =>
  import("./Page/reports/sub-report/ProductReport").then((m) => ({
    default: m.ProductReport,
  })),
);
const PurchaseReturnsReport = React.lazy(() =>
  import("./Page/reports/sub-report/PurchaseReturnsReport").then((m) => ({
    default: m.PurchaseReturnsReport,
  })),
);
const PurchasePaymentHistoryReport = React.lazy(() =>
  import("./Page/reports/sub-report/PurchasePaymentHistoryReport").then(
    (m) => ({
      default: m.PurchasePaymentHistoryReport,
    }),
  ),
);
const ExpenseBySellerCategoryReport = React.lazy(() =>
  import("./Page/reports/sub-report/ExpenseBySellerCategoryReport").then(
    (m) => ({
      default: m.ExpenseBySellerCategoryReport,
    }),
  ),
);
const DebtorsReport = React.lazy(() =>
  import("./Page/reports/sub-report/DebtorsReport").then((m) => ({
    default: m.DebtorsReport,
  })),
);
const CreditorsReport = React.lazy(() =>
  import("./Page/reports/sub-report/CreditorsReport").then((m) => ({
    default: m.CreditorsReport,
  })),
);
const CustomerReport = React.lazy(() =>
  import("./Page/reports/sub-report/CustomerReport").then((m) => ({
    default: m.CustomerReport,
  })),
);
const SupplierReport = React.lazy(() =>
  import("./Page/reports/sub-report/SupplierReport").then((m) => ({
    default: m.SupplierReport,
  })),
);
const RawStockIssueReport = React.lazy(() =>
  import("./Page/reports/sub-report/RawStockIssueReport").then((m) => ({
    default: m.RawStockIssueReport,
  })),
);
const RawMaterialPurchasedReport = React.lazy(() =>
  import("./Page/reports/sub-report/RawMaterialPurchasedReport").then((m) => ({
    default: m.RawMaterialPurchasedReport,
  })),
);
const ProductionReport = React.lazy(() =>
  import("./Page/reports/sub-report/ProductionReport").then((m) => ({
    default: m.ProductionReport,
  })),
);
const TransferReport = React.lazy(() =>
  import("./Page/reports/sub-report/TransferReport").then((m) => ({
    default: m.TransferReport,
  })),
);
const PayrollSummaryReport = React.lazy(() =>
  import("./Page/reports/sub-report/PayrollSummaryReport").then((m) => ({
    default: m.PayrollSummaryReport,
  })),
);
const WebInfoManagement = React.lazy(() =>
  import("./Page/web-info/WebInfoManagement").then((m) => ({
    default: m.WebInfoManagement,
  })),
);
const TenantsPage = React.lazy(() =>
  import("./Page/system-admin/TenantsPage").then((m) => ({
    default: m.TenantsPage,
  })),
);
const TenantDetailPage = React.lazy(() =>
  import("./Page/system-admin/TenantDetailPage").then((m) => ({
    default: m.TenantDetailPage,
  })),
);
const DashboardOverview = React.lazy(() =>
  import("./Page/dashboard-overview/DashboardOverview").then((m) => ({
    default: m.DashboardOverview,
  })),
);
const AdDetailPage = React.lazy(() =>
  import("./Page/ads/AdDetailPage").then((m) => ({
    default: m.AdDetailPage,
  })),
);
const AdsListPage = React.lazy(() =>
  import("./Page/ads/AdsListPage").then((m) => ({
    default: m.AdsListPage,
  })),
);
const BillingPage = React.lazy(() =>
  import("./Page/billing/BillingPage").then((m) => ({
    default: m.BillingPage,
  })),
);

const RoutesTrackingPage = React.lazy(() =>
  import("./Page/routes-tracking/RoutesTrackingPage").then((m) => ({
    default: m.RoutesTrackingPage,
  })),
);

const NotFoundPage = React.lazy(() =>
  import("./Page/not-found/NotFoundPage").then((m) => ({
    default: m.NotFoundPage,
  })),
);
const PublicInvoicePage = React.lazy(() =>
  import("./Page/public-invoice/PublicInvoicePage").then((m) => ({
    default: m.PublicInvoicePage,
  })),
);
const PublicReturnInvoicePage = React.lazy(() =>
  import("./Page/public-return-invoice/PublicReturnInvoicePage").then((m) => ({
    default: m.PublicReturnInvoicePage,
  })),
);

function App() {
  return (
    <div className="min-h-screen bg-background text-foreground transition-colors">
      <Router>
        <KeyboardHandlerNavToPos />

        <Routes>
          <Route
            path={"/*"}
            element={
              <Suspense fallback={<PageLoading />}>
                <Routes>
                  <Route path={ROUTE.login} element={<SignInPage />} />
                  <Route
                    path={ROUTE.forgotPassword}
                    element={<ForgotPasswordPage />}
                  />
                  <Route
                    path={ROUTE.loginSuccess}
                    element={<LoginSuccessPage />}
                  />
                  <Route path="/auto-login" element={<AutoLoginPage />} />
                  <Route
                    path="/:tenantSlug/:id"
                    element={<PublicInvoicePage />}
                  />
                  <Route
                    path="/:tenantSlug/returns/:id"
                    element={<PublicReturnInvoicePage />}
                  />
                  <Route path="*" element={<NotFoundPage />} />
                </Routes>
              </Suspense>
            }
          />

          <Route
            path={"/system/*"}
            element={
              <ProtectedRoute>
                <SidebarProvider>
                  <AppSidebar />
                  <main className="flex-1 w-full bg-background text-foreground overflow-y-auto transition-colors">
                    <Suspense fallback={<PageLoading />}>
                      <ReportStoreProvider>
                        <Routes>
                          <Route
                            path={ROUTE.dashboard_overview}
                            element={
                              <ProtectedRoute feature="dashboard_overview">
                                <DashboardOverview />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={ROUTE.sales_billing}
                            element={
                              <ProtectedRoute feature="sales_billing">
                                <POSPage />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={ROUTE.sales_purchase}
                            element={
                              <ProtectedRoute feature="sales_billing">
                                <SalesPurchasePage />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={ROUTE.pre_bookings}
                            element={
                              <ProtectedRoute feature="pre_bookings">
                                <PreBookingsPage />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={ROUTE.employee_manage}
                            element={
                              <ProtectedRoute feature="employee_manage">
                                <EmployeesPage />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={ROUTE.attendance_manage}
                            element={
                              <ProtectedRoute feature="attendance_manage">
                                <AttendanceRegisterPage />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={ROUTE.shift_manage}
                            element={
                              <ProtectedRoute feature="payroll_manage">
                                <ShiftManagementPage />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={ROUTE.payroll_policy}
                            element={
                              <ProtectedRoute feature="payroll_manage">
                                <PayrollPolicyPage />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={ROUTE.payroll_manage}
                            element={
                              <ProtectedRoute feature="payroll_manage">
                                <PayrollManagementPage />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={ROUTE.salary_compensation}
                            element={
                              <ProtectedRoute feature="payroll_manage">
                                <SalaryCompensationPage />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={ROUTE.leave_manage}
                            element={
                              <ProtectedRoute feature="leave_manage">
                                <LeaveCalendar />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={ROUTE.user_manage}
                            element={
                              <ProtectedRoute feature="user_manage">
                                <UsersPage />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={ROUTE.access_policies}
                            element={
                              <ProtectedRoute feature="access_policies">
                                <AccessPoliciesPage />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={ROUTE.store_manage}
                            element={
                              <ProtectedRoute feature="store_manage">
                                <StoresPage />
                              </ProtectedRoute>
                            }
                          />

                          <Route
                            path={ROUTE.route_manage}
                            element={
                              <ProtectedRoute feature="route_manage">
                                <RoutesPage />
                              </ProtectedRoute>
                            }
                          />

                          <Route
                            path={ROUTE.route_tracking}
                            element={
                              <ProtectedRoute feature="route_tracking">
                                <RoutesTrackingPage />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={ROUTE.billing}
                            element={
                              <ProtectedRoute>
                                <BillingPage />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={ROUTE.bank_manage}
                            element={
                              <ProtectedRoute feature="bank_manage">
                                <BankAccountsPage />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={ROUTE.whatsapp_chatbot}
                            element={
                              <ProtectedRoute feature="whatsapp-chatbot">
                                <WhatsAppChatbotPage />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={ROUTE.online_orders}
                            element={
                              <ProtectedRoute feature="online-orders">
                                <OnlineOrdersPage />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={ROUTE.ad_detail}
                            element={
                              <ProtectedRoute feature="ad-list">
                                <AdDetailPage />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={ROUTE.ad_list}
                            element={
                              <ProtectedRoute feature="ad-list">
                                <AdsListPage />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={ROUTE.product_manage}
                            element={
                              <ProtectedRoute feature="product_manage">
                                <ProductsPage />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={ROUTE.barcode_editor}
                            element={
                              <ProtectedRoute feature="barcode_editor">
                                <BarcodeEditor />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={ROUTE.purchase_manage}
                            element={
                              <ProtectedRoute feature="purchase_manage">
                                <PurchasesPage />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={ROUTE.raw_material_manage}
                            element={
                              <ProtectedRoute feature="raw_material_manage">
                                <RawMaterialsPage />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={ROUTE.raw_material_purchase}
                            element={
                              <ProtectedRoute feature="raw_material_purchase">
                                <RawPurchasesPage />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={ROUTE.raw_material_purchase_form}
                            element={
                              <ProtectedRoute feature="raw_material_purchase">
                                <RawPurchaseFormStandalonePage />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={`${ROUTE.raw_material_purchase_form}/:id`}
                            element={
                              <ProtectedRoute feature="raw_material_purchase">
                                <RawPurchaseFormStandalonePage />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={ROUTE.recipe_manage}
                            element={
                              <ProtectedRoute feature="recipe_manage">
                                <RecipesPage />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={ROUTE.workshop_manage}
                            element={
                              <ProtectedRoute feature="workshop_manage">
                                <WorkshopsPage />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={ROUTE.workshop_detail}
                            element={
                              <ProtectedRoute feature="workshop_detail">
                                <WorkshopDetailPage />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={ROUTE.production_manage}
                            element={
                              <ProtectedRoute feature="production_manage">
                                <ProductionPage />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={ROUTE.stock_transfer}
                            element={
                              <ProtectedRoute feature="stock_transfer">
                                <StockTransferPage />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={ROUTE.stock_adjustment}
                            element={
                              <ProtectedRoute feature="stock_adjustment">
                                <StockAdjustmentPage />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={ROUTE.stock_history}
                            element={
                              <ProtectedRoute feature="stock_history">
                                <StockHistoryPage />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={`${ROUTE.store_live_tracking}/:storeId`}
                            element={
                              <ProtectedRoute feature="store_live_tracking">
                                <StoreLiveTracking />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={ROUTE.repair_jobs}
                            element={
                              <ProtectedRoute feature="repair_jobs">
                                <RepairJobsPage />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={ROUTE.courier_manage}
                            element={
                              <ProtectedRoute feature="courier_manage">
                                <CouriersPage />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={ROUTE.courier_ledger}
                            element={
                              <ProtectedRoute feature="courier_manage">
                                <CourierLedgerPage />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={ROUTE.sales_history}
                            element={
                              <ProtectedRoute feature="sales_history">
                                <SellingHistory />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={ROUTE.sales_return}
                            element={
                              <ProtectedRoute feature="sales_return">
                                <ReturnsHistory />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={ROUTE.sales_expenses}
                            element={
                              <ProtectedRoute feature="sales_expenses">
                                <ExpensesPage />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={ROUTE.customer_ledger}
                            element={
                              <ProtectedRoute feature="customer_credits">
                                <CustomerLedgerPage />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={ROUTE.supplier_ledger}
                            element={
                              <ProtectedRoute feature="customer_credits">
                                <SupplierLedgerPage />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={ROUTE.credits_summery}
                            element={
                              <ProtectedRoute feature="credits_summery">
                                <CreditsPage />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={ROUTE.customer_manage}
                            element={
                              <ProtectedRoute feature="customer_manage">
                                <CustomersPage />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={ROUTE.supplier_manage}
                            element={
                              <ProtectedRoute feature="supplier_manage">
                                <SuppliersPage />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={ROUTE.sales_cheques}
                            element={
                              <ProtectedRoute feature="sales_cheques">
                                <ChequesPage />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={ROUTE.sales_quotation}
                            element={
                              <ProtectedRoute feature="sales_quotation">
                                <QuotationsPage />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={ROUTE.sales_drafts}
                            element={
                              <ProtectedRoute feature="sales_billing">
                                <DraftsPage />
                              </ProtectedRoute>
                            }
                          />

                          {/* Report */}
                          <Route
                            path={ROUTE.report_sales}
                            element={
                              <ProtectedRoute feature="report_sales">
                                <SalesReports />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={ROUTE.report_inventory}
                            element={
                              <ProtectedRoute feature="report_inventory">
                                <InventoryReports />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={ROUTE.report_purchase}
                            element={
                              <ProtectedRoute feature="report_purchase">
                                <PurchaseReports />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={ROUTE.report_expenses}
                            element={
                              <ProtectedRoute feature="report_expenses">
                                <ExpenseReports />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={ROUTE.report_credit}
                            element={
                              <ProtectedRoute feature="report_credit">
                                <CreditReports />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={ROUTE.report_others}
                            element={
                              <ProtectedRoute feature="report_others">
                                <OtherReports />
                              </ProtectedRoute>
                            }
                          />

                          {/* Sales Report */}
                          <Route
                            path={REPORT.sales_ledger}
                            element={
                              <ProtectedRoute feature="report_sales">
                                <SalesLedgerReport />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={REPORT.item_profit}
                            element={
                              <ProtectedRoute
                                feature="report_sales"
                                policy="reports.view_profit"
                              >
                                <ItemProfitReport />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={REPORT.cash_flow}
                            element={
                              <ProtectedRoute feature="report_sales">
                                <CashFlowReport />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={REPORT.cheques}
                            element={
                              <ProtectedRoute feature="report_sales">
                                <ChequesReport />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={REPORT.discounts}
                            element={
                              <ProtectedRoute feature="report_sales">
                                <DiscountsReport />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={REPORT.non_cash_payments}
                            element={
                              <ProtectedRoute feature="report_sales">
                                <NonCashPaymentsReport />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={REPORT.employee_performance}
                            element={
                              <ProtectedRoute feature="report_sales">
                                <EmployeePerformanceReport />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={REPORT.sign_off_list}
                            element={
                              <ProtectedRoute feature="report_sales">
                                <SignOffListReport />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={REPORT.sign_off_detail}
                            element={
                              <ProtectedRoute feature="report_sales">
                                <SignOffDetailReport />
                              </ProtectedRoute>
                            }
                          />

                          {/* Inventory Report */}
                          <Route
                            path={REPORT.product_stock}
                            element={
                              <ProtectedRoute feature="report_inventory">
                                <ProductStockReport />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={REPORT.expiring_items}
                            element={
                              <ProtectedRoute feature="report_inventory">
                                <ExpiringItemsReport />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={REPORT.purchases}
                            element={
                              <ProtectedRoute feature="report_inventory">
                                <PurchasesReport />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={REPORT.purchased_products}
                            element={
                              <ProtectedRoute feature="report_inventory">
                                <PurchasedProductsReport />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={REPORT.returned_items}
                            element={
                              <ProtectedRoute feature="report_inventory">
                                <ReturnedItemsReport />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={REPORT.sold_items}
                            element={
                              <ProtectedRoute feature="report_inventory">
                                <SoldItemsReport />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={REPORT.couriers}
                            element={
                              <ProtectedRoute feature="report_others">
                                <CourierReport />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={REPORT.by_cashier}
                            element={
                              <ProtectedRoute feature="report_sales">
                                <ReportByCashier />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={REPORT.total_items}
                            element={
                              <ProtectedRoute feature="report_inventory">
                                <TotalItemsReport />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={REPORT.products}
                            element={
                              <ProtectedRoute feature="report_inventory">
                                <ProductReport />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={REPORT.purchase_returns}
                            element={
                              <ProtectedRoute feature="report_purchase">
                                <PurchaseReturnsReport />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={REPORT.purchase_payments}
                            element={
                              <ProtectedRoute feature="report_purchase">
                                <PurchasePaymentHistoryReport />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={REPORT.expense_by_seller}
                            element={
                              <ProtectedRoute feature="report_expenses">
                                <ExpenseBySellerCategoryReport />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={REPORT.debtors}
                            element={
                              <ProtectedRoute feature="report_credit">
                                <DebtorsReport />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={REPORT.creditors}
                            element={
                              <ProtectedRoute feature="report_credit">
                                <CreditorsReport />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={REPORT.customers}
                            element={
                              <ProtectedRoute feature="report_credit">
                                <CustomerReport />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={REPORT.suppliers}
                            element={
                              <ProtectedRoute feature="report_credit">
                                <SupplierReport />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={REPORT.raw_stock_issue}
                            element={
                              <ProtectedRoute feature="report_others">
                                <RawStockIssueReport />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={REPORT.raw_material_purchases}
                            element={
                              <ProtectedRoute feature="report_others">
                                <RawMaterialPurchasedReport />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={REPORT.productions}
                            element={
                              <ProtectedRoute feature="report_others">
                                <ProductionReport />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={REPORT.transfers}
                            element={
                              <ProtectedRoute feature="report_others">
                                <TransferReport />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={REPORT.payroll_summary}
                            element={
                              <ProtectedRoute feature="report_others">
                                <PayrollSummaryReport />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path={ROUTE.web_info}
                            element={
                              <ProtectedRoute feature="web_info">
                                <WebInfoManagement />
                              </ProtectedRoute>
                            }
                          />
                          <Route path="*" element={<NotFoundPage />} />
                        </Routes>
                      </ReportStoreProvider>
                    </Suspense>
                  </main>
                </SidebarProvider>
              </ProtectedRoute>
            }
          />

          <Route
            path={"/system-admin/*"}
            element={
              <ProtectedRoute>
                <div className="min-h-screen bg-gray-50">
                  <Suspense fallback={<PageLoading />}>
                    <Routes>
                      <Route
                        path={ROUTE.system_admin_tenants}
                        element={<TenantsPage />}
                      />
                      <Route
                        path={`${ROUTE.system_admin_tenants}/:id`}
                        element={<TenantDetailPage />}
                      />

                      <Route path="*" element={<NotFoundPage />} />
                    </Routes>
                  </Suspense>
                </div>
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
